import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Avatar, AvatarProps, Tooltip, TooltipProps } from '@mui/material';

import { collectionTypeGuard, PageContentType } from '@models/Content';

import { ContentIcon, ContentIconProps } from './ContentIcon';

export type ContentTypeAvatarProps = Omit<AvatarProps, 'color' | 'variant'> & {
  contentType: PageContentType;
  hideTooltip?: boolean;
  IconProps?: Omit<ContentIconProps, 'contentType' | 'hideTooltip' | 'TooltipProps'>;
  TooltipProps?: Partial<Omit<TooltipProps, 'children'>>;
};

export const ContentTypeAvatar: FC<ContentTypeAvatarProps> = ({
  contentType,
  hideTooltip,
  TooltipProps: tooltipProps,
  ...rest
}) => {
  const { t } = useTranslation();

  const isCollection = collectionTypeGuard(contentType);

  const baseContentType = isCollection ? 'collection' : contentType;

  return (
    <Tooltip title={hideTooltip ? undefined : t(`contentType.${contentType}`)} {...tooltipProps}>
      <Avatar
        {...rest}
        sx={{
          ...(rest.sx || {}),
          bgcolor: theme => theme.palette.custom.content[baseContentType],
          color: theme =>
            theme.palette.getContrastText(theme.palette.custom.content[baseContentType]),
          height: 24,
          width: 24,
          fontSize: 16,
        }}
      >
        <ContentIcon contentType={contentType} fontSize='inherit' hideTooltip />
      </Avatar>
    </Tooltip>
  );
};
